import { render, staticRenderFns } from "./AddCasesDialog.vue?vue&type=template&id=0b488aca"
import script from "./AddCasesDialog.vue?vue&type=script&lang=js"
export * from "./AddCasesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports